import React from 'react';
import { ILaborSchedule } from 'types';
import { ShiftRowCol, ShiftRowLabel, ShiftRowLayout, ShiftRowValue } from './styles';
import { formatBreaksList, formatDuration, formatLocalTime, getScheduleDurationMinutes } from './utils';

interface IShiftRowProps {
  schedule: ILaborSchedule;
  timezone: string;
}

export const ShiftRow: React.FC<IShiftRowProps> = ({ schedule, timezone }) => {
  const durationMinutes = getScheduleDurationMinutes(schedule);

  return (
    <ShiftRowLayout data-cy="shift-row">
      <ShiftRowCol style={{ flex: '2 1 240px' }}>
        <ShiftRowLabel>Job</ShiftRowLabel>
        <ShiftRowValue data-cy="shift-job-title">{schedule.jobTitle}</ShiftRowValue>
      </ShiftRowCol>

      <ShiftRowCol style={{ flex: '1 1 100px' }}>
        <ShiftRowLabel>Clock in</ShiftRowLabel>
        <ShiftRowValue data-cy="shift-clock-in">{formatLocalTime({ isoInstant: schedule.start, timezone })}</ShiftRowValue>
      </ShiftRowCol>

      <ShiftRowCol style={{ flex: '1 1 100px' }}>
        <ShiftRowLabel>Clock out</ShiftRowLabel>
        <ShiftRowValue data-cy="shift-clock-out">{schedule.end ? formatLocalTime({ isoInstant: schedule.end, timezone }) : 'Missing'}</ShiftRowValue>
      </ShiftRowCol>

      <ShiftRowCol style={{ flex: '1.5 1 160px' }}>
        <ShiftRowLabel>Breaks</ShiftRowLabel>
        <ShiftRowValue data-cy="shift-breaks">{formatBreaksList({ schedule, timezone })}</ShiftRowValue>
      </ShiftRowCol>

      <ShiftRowCol align="right" style={{ flex: '1 1 100px' }}>
        <ShiftRowLabel>Duration</ShiftRowLabel>
        <ShiftRowValue data-cy="shift-duration">{durationMinutes !== null ? formatDuration(durationMinutes) : '—'}</ShiftRowValue>
      </ShiftRowCol>
    </ShiftRowLayout>
  );
};
